import { CSS } from '@grupoboticario/flora-react'

export const dayItemBoxCss: CSS = {
  marginBottom: '$6'
}

export const dayHeaderCss: CSS = {
  marginBottom: '$4'
}

export const dateGridCss: CSS = {
  gridTemplateColumns: '1fr',
  gap: '$4',
  '@desktop': { gridTemplateColumns: 'repeat(3, 1fr)' }
}

export const ticketGridCss = (isFactoryVisit: boolean): CSS => ({
  gridTemplateColumns: '1fr',
  gap: '$4',
  '@desktop': {
    gridTemplateColumns: isFactoryVisit ? '1fr' : 'repeat(2, 1fr)'
  }
})

export const deleteBorderlessCss: CSS = {
  borderColor: 'none',
  marginTop: '$4'
}
